// Importación de rutas extras
import {
  FILE_EXPLORE_ROUTE_ACCESS,
  HELP_ROUTES_FILE_EXPLORE,
  combineRouteAccess,
  combineHelpRoutes,
} from "./file-explorer.config.js";

export const ROUTE_ACCESS = {
  "/dashboard": ["Administrador", "vehicle", "thirdParty", "RRHH", "CT", "CO", "Manifiestos de Carga", "TDCLLV", "TDCLLU", "CUV", "LUV", "Mantenimiento", "MTTO"],
  "/transport-calculator": [
    "Administrador",
    "vehicle",
    "thirdParty",
    "RRHH",
  ],
  "/validate-vehicle-inspection": [
    "Administrador",
    "vehicle",
    "thirdParty",
    "RRHH",
  ],
  "/location-reports": [
    "Administrador",
    "vehicle",
    "thirdParty",
    "RRHH",
    "CT",
  ],
  "/vehicle-tracking": [
    "Administrador",
    "vehicle",
    "thirdParty",
    "RRHH",
    "CT",
    "Coordinador de operaciones",
    "TDCLLV",
    "CUV",
    "LUV",
    "MC",
    "MTTO",
    "Mantenimiento",
    "HSEQ"
  ],
  "/multi-tracking": ["Administrador","CT", "CO", "TDCLLV", "CUV", "LUV", "MC", "MTTO", "Mantenimiento", "HSEQ", "RRHH"],
  "/transport-calculator/:id": [
    "Administrador",
    "vehicle",
    "thirdParty",
    "RRHH",
  ],
  "/pending-changes-dashboard": ["Administrador", "CO"],
  "/sicetac-admin": ["Administrador"],
  "/agregar-info": ["Administrador", "vehicle"],
  "/reportes": ["Administrador"],
  "/perfil": ["Administrador", "vehicle", "thirdParty", "RRHH"],
  "/satellite-uploader": ["Administrador"],
  "/register": ["Administrador"],
  "/trends": ["Administrador", "CT"],
  "/hotspots": ["Administrador", "CT"],
  "/repeat-offenders": ["Administrador", "CT"],
  "/alerts-persons": ["Administrador", "RRHH", "TDCLLU", "CUV", "LUV", "CO"],
  "/geofences-travel-and-more": ["Administrador", "RRHH"],
  "/wssp-connection": ["Administrador"],
  // Rutas para el manejo de recursos humanos
  "/persons": ["Administrador", "RRHH", "ADO", "CO", "TDCLLU", "CUV", "LUV"],
  // Ruta dinámica de listado de usuarios por rol
  "/persons/role/:roleId": ["Administrador", "RRHH", "CO", "TDCLLU", "CUV", "LUV"],
  "/persons/setting/data": ["Administrador", "RRHH", "CO"],
  // Rutas para el sistema de carpetas (RH)
  "/persons/folders": ["Administrador", "RRHH", "CO"],

  // Carpetas específicas por operadores
  "/persons/operators": ["Administrador", "TDCLL Usuarios", "RRHH", "CUV", "LUV", "CO"],

  // Nuevas rutas de carpetas por tipo de personal
  "/persons/folders/:folderId": ["Administrador", "RRHH", "CO"],
  "/persons/folders/:folderId/operators": ["Administrador", "TDCLL Usuarios", "RRHH", "CUV", "LUV", "CO"],
  "/persons/folders/:folderId/administrators": ["Administrador", "RRHH"],
  "/persons/folders/:folderId/rrhh": ["Administrador", "RRHH"],
  "/persons/folders/:folderId/owners": ["Administrador", "RRHH"],
  "/persons/folders/:folderId/third-parties": ["Administrador", "RRHH"],

  // Rutas de gestión de carpetas
  "/persons/folders/manage/:roleId": ["Administrador", "RRHH", "CO", "CUV"],
  "/persons/folders/unassigned/:roleId": ["Administrador", "RRHH", "CO", "CUV"],
  "/persons/folders/all/:roleId": ["Administrador", "RRHH", "CO", "CUV"],
  "/persons/add/user/:id": ["Administrador", "RRHH", "CO", "CUV", "LUV"],
  "/persons/profile/:id": ["Administrador", "RRHH", "TDCLLU", "CUV", "LUV", "CO", "MC", "MTTO"],
  "/vehicles": ["Administrador", "ADO", "CO", "TDCLLV", "CUV", "LUV"],
  "/alerts-vehicles": ["Administrador", "ADO", "vehicle", "CO", "TDCLLV", "CUV", "LUV"],
  "/vehicles/:id": ["Administrador", "ADO", "CO", "TDCLLV", "CUV", "LUV", "MC", "MTTO"],
  "/vehicles/update/:id": ["Administrador", "ADO", "CO"],
  "/vehicles/setting/data": ["Administrador", "ADO", "CO", "CT"],
  "/vehicles/owner/:id": ["Administrador", "ADO", "CO"],
  "/vehicles/add/vehicle": ["Administrador", "ADO", "CO", "CUV", "LUV"],
  "/vehicles/add/user/:id": ["Administrador", "ADO", "CO"],
  "/carriers": ["Administrador"],
  "/message": ["Administrador", "vehicle", "thirdParty", "CO", "MC"],
  "/manifest-control": ["MC", "Administrador"],
  "/manifest-control/guides": ["Administrador", "MC"],
  "/manifest-control/guide-dashboard": ["Administrador", "MC", "RRHH"],
  "/manifest-control/setting/data": ["Administrador", "MC"],

  // Rutas de Tarifario
  "/rates": ["Administrador", "CO", "MC"],
  "/rates/:id": ["Administrador"],
  "/rates/setting/data": ["Administrador"],
  "/rates/advances": ["Administrador", "CO", "MC"],
  "/rates/advances/:id/confirm": ["Administrador", "CO", "MC"],

  //Rutas para Operaciones
  "/scheduler": ["Administrador", "ADO", "Operador", "CO", "CT", "MC", "RRHH"],
  "/scheduler/impala": ["Administrador", "ADO", "Operador", "CO", "CT", "MC", "RRHH"],
  "/scheduler/frontera": ["Administrador", "ADO", "Operador", "CO", "CT", "MC", "RRHH"],
  "/scheduler/terpel": ["Administrador", "ADO", "Operador", "CO", "CT", "MC", "RRHH"],
  "/scheduler/ecopetrol": ["Administrador", "ADO", "Operador", "CO", "CT", "MC", "RRHH"],
  "/scheduler/gran-tierra-energy": ["Administrador", "ADO", "Operador", "CO", "CT", "MC", "RRHH"],
  "/scheduler/g-t-e": ["Administrador", "ADO", "Operador", "CO", "CT", "MC", "RRHH"],
  "/scheduler/gran-tierra-energy-liquida": ["Administrador", "ADO", "Operador", "CO", "CT", "MC", "RRHH"],
  "/scheduler/gran-tierra-energy-seca": ["Administrador", "ADO", "Operador", "CO", "CT", "MC", "RRHH"],
  "/scheduler/emerald-energy": ["Administrador", "ADO", "Operador", "CO", "CT", "MC", "RRHH"],
  "/scheduler/terpel-norte": ["Administrador", "ADO", "Operador", "CO", "CT", "MC", "RRHH"],
  "/scheduler/terpel-sur": ["Administrador", "ADO", "Operador", "CO", "CT", "MC", "RRHH"],
  "/scheduler/dobletroques-ecopetrol": ["Administrador", "ADO", "Operador", "CO", "CT", "MC", "RRHH"],
  "/scheduler/regalias-ecopetrol": ["Administrador", "ADO", "Operador", "CO", "CT", "MC", "RRHH"],
  "/scheduler/emerald": ["Administrador", "ADO", "Operador", "CO", "CT", "MC", "RRHH"],
  "/scheduler/twm": ["Administrador", "ADO", "Operador", "CO", "CT", "MC", "RRHH"],
  "/scheduler/servicios-petroleros": ["Administrador", "ADO", "Operador", "CO", "CT", "MC", "RRHH"],
  "/scheduler/inspectrol": ["Administrador", "ADO", "Operador", "CO", "CT", "MC", "RRHH"],
  "/scheduler/soluciones-cap": ["Administrador", "ADO", "Operador", "CO", "CT", "MC", "RRHH"],
  "/scheduler/confipetrol": ["Administrador", "ADO", "Operador", "CO", "CT", "MC", "RRHH"],
  "/scheduler/servipvalencia": ["Administrador", "ADO", "Operador", "CO", "CT", "MC", "RRHH"],
  "/scheduler/parex": ["Administrador", "ADO", "Operador", "CO", "CT", "MC", "RRHH"],
  "/scheduler/patterson": ["Administrador", "ADO", "Operador", "CO", "CT", "MC", "RRHH"],
  "/operations/setting/data": ["Administrador"],

  // Rutas de Help (sin documentación)
  "/help": ["Administrador", "vehicle", "thirdParty", "RRHH", "CT", "CO", "MC", "ADO", "Operador", "Manifiestos de Carga", "Coordinador de operaciones", "TDCLL Usuarios", "TDCLLV", "TDCLLU", "CUV", "LUV"],
  "/help/tickets": ["Administrador", "vehicle", "thirdParty", "RRHH", "CT", "CO", "MC", "ADO", "Operador", "Manifiestos de Carga", "Coordinador de operaciones", "TDCLL Usuarios", "TDCLLV", "TDCLLU", "CUV", "LUV"],
  "/help/privacy/accessibility": ["Administrador", "vehicle", "thirdParty", "RRHH", "CT", "CO", "MC", "ADO", "Operador", "Manifiestos de Carga", "Coordinador de operaciones", "TDCLL Usuarios", "TDCLLV", "TDCLLU", "CUV", "LUV"],
  "/help/privacy/data-processing": ["Administrador", "vehicle", "thirdParty", "RRHH", "CT", "CO", "MC", "ADO", "Operador", "Manifiestos de Carga", "Coordinador de operaciones", "TDCLL Usuarios", "TDCLLV", "TDCLLU", "CUV", "LUV"],
  "/help/privacy/terms-conditions": ["Administrador", "vehicle", "thirdParty", "RRHH", "CT", "CO", "MC", "ADO", "Operador", "Manifiestos de Carga", "Coordinador de operaciones", "TDCLL Usuarios", "TDCLLV", "TDCLLU", "CUV", "LUV"],
  "/help/contact": ["Administrador", "vehicle", "thirdParty", "RRHH", "CT", "CO", "MC", "ADO", "Operador", "Manifiestos de Carga", "Coordinador de operaciones", "TDCLL Usuarios", "TDCLLV", "TDCLLU", "CUV", "LUV"],
  "/help/tickets/department/:departmentId": ["Administrador", "vehicle", "thirdParty", "RRHH", "CT", "CO", "MC", "ADO", "Operador", "Manifiestos de Carga", "Coordinador de operaciones", "TDCLL Usuarios", "TDCLLV", "TDCLLU", "CUV", "LUV"],
  "/help/privacy/information-protection": ["Administrador", "vehicle", "thirdParty", "RRHH", "CT", "CO", "MC", "ADO", "Operador", "Manifiestos de Carga", "Coordinador de operaciones", "TDCLL Usuarios", "TDCLLV", "TDCLLU", "CUV", "LUV"],
  "/help/documentation/tracking": ["Administrador", "vehicle", "thirdParty", "RRHH", "CT", "CO", "MC", "ADO", "Operador", "Manifiestos de Carga", "Coordinador de operaciones", "TDCLL Usuarios", "TDCLLV", "TDCLLU", "CUV", "LUV"],
  "/help/documentation/tracking/:docId": ["Administrador", "vehicle", "thirdParty", "RRHH", "CT", "CO", "MC", "ADO", "Operador", "Manifiestos de Carga", "Coordinador de operaciones", "TDCLL Usuarios", "TDCLLV", "TDCLLU", "CUV", "LUV"],

  // Ruta de prueba: Árbol de operaciones (solo admin)
  "/operations-tree": ["Administrador"],
  "/global-search": ["Administrador", "vehicle", "thirdParty", "RRHH", "CT", "CO", "MC", "MTTO", "Mantenimiento", "ADO", "Operador", "Manifiestos de Carga", "Coordinador de operaciones", "TDCLL Usuarios", "TDCLLV", "TDCLLU", "CUV", "LUV"],

  // Rutas de Preoperacional
  "/gerenciamiento-viajes/config": ["Administrador", "RRHH"],
  "/preoperacional/config": ["Administrador", "Mantenimiento", "RRHH"],
  "/gerenciamiento-viajes": ["Administrador", "RRHH"],
  "/preoperacional": ["Administrador", "Mantenimiento", "RRHH"],

  // Rutas del modulo SARLAFT / HSE
  "/hse/dashboard": ["Administrador", "RRHH", "HSEQ"],
  "/hse/configuracion": ["Administrador", "RRHH", "HSEQ"],
  "/hse/previsualizar": ["Administrador", "RRHH", "HSEQ"],
};

// Combinación de rutas para uso completo
export const COMPLETE_ROUTE_ACCESS = combineRouteAccess(
  ROUTE_ACCESS,
  FILE_EXPLORE_ROUTE_ACCESS
);

export const PERSON_ROUTES = {
  main: {
    path: "/persons",
    title: "Personas",
    subtitle: "Personas/",
  },
  // Rutas para carpetas
  // Vista principal de carpetas
  folders: {
    path: "/persons/folders",
    title: "Carpetas",
    subtitle: "Personas/Carpetas",
    description: "Sistema de organización por carpetas",
    roleId: null, // Se establece dinámicamente
  },

  // Vista de una carpeta específica
  folderView: {
    path: "/persons/folders/:folderId",
    title: "Carpeta",
    subtitle: "Personas/Carpetas/{folderName}",
    description: "Vista detallada de carpeta específica",
  },

  // Operadores dentro de una carpeta específica
  folderOperators: {
    path: "/persons/folders/:folderId/operators",
    title: "Operadores",
    subtitle: "Personas/Carpetas/{folderName}/Operadores",
    roleId: 5,
  },

  // Administradores dentro de una carpeta específica
  folderAdministrators: {
    path: "/persons/folders/:folderId/administrators",
    title: "Administradores",
    subtitle: "Personas/Carpetas/{folderName}/Administradores",
    roleId: 4,
  },

  // Recursos Humanos dentro de una carpeta específica
  folderRRHH: {
    path: "/persons/folders/:folderId/rrhh",
    title: "Recursos Humanos",
    subtitle: "Personas/Carpetas/{folderName}/Recursos Humanos",
    roleId: 1,
  },

  // Propietarios dentro de una carpeta específica
  folderOwners: {
    path: "/persons/folders/:folderId/owners",
    title: "Propietarios",
    subtitle: "Personas/Carpetas/{folderName}/Propietarios",
    roleId: 6,
  },

  // Terceros dentro de una carpeta específica
  folderThirdParties: {
    path: "/persons/folders/:folderId/third-parties",
    title: "Terceros",
    subtitle: "Personas/Carpetas/{folderName}/Terceros",
    roleId: 3,
  },

  // Gestión de carpetas para un rol específico
  foldersManage: {
    path: "/persons/folders/manage/:roleId",
    title: "Gestionar Carpetas",
    subtitle: "Personas/Carpetas/Gestionar/{roleName}",
    description: "Interfaz de administración de carpetas",
  },

  // Usuarios no asignados para un rol específico
  foldersUnassigned: {
    path: "/persons/folders/unassigned/:roleId",
    title: "Sin Asignar",
    subtitle: "Personas/Carpetas/Sin Asignar/{roleName}",
    description: "Usuarios que no están en ninguna carpeta",
  },

  foldersAllUsers: {
    path: "/persons/folders/all/:roleId",
    title: "Todos los usuarios",
    subtitle: "Personas/Carpetas/Todos/{roleName}",
    description: "Vista completa de todos los usuarios del rol",
  },

  // Ruta dinámica unificada para listado de usuarios por rol
  roleList: {
    path: "/persons/role/:roleId",
    title: "Personas",
    subtitle: "Personas/{roleName}",
  },

  // Operadores — mantiene FoldersMainView como excepción
  operators: {
    path: "/persons/operators",
    title: "Operadores",
    subtitle: "Personas/Operadores",
    roleId: 5,
  },

  // Rutas de utilidad (sin cambios)
  addUser: {
    path: "/persons/add/user/:id",
    title: "Agregar Persona",
    subtitle: "Personas/{id}",
  },
  profile: {
    path: "/persons/profile/:id",
    title: "Perfil Persona",
    subtitle: "Personas/{id}",
  },
  setting: {
    path: "/persons/setting/data",
    title: "Configuracion de data",
    subtitle: "Personas/Configuración",
  },
};

export const VEHICLES_ROUTES = {
  main: {
    path: "/vehicles",
    title: "Vehículos",
    subtitle: "Vehículos",
  },
  vechicle: {
    path: "/vehicles/:id",
    title: "vehiculo",
    subtitle: "Vehículos/{id}",
  },
  updated: {
    path: "/vehicles/update/:id",
    title: "Actulizar vehiculo",
    subtitle: "Vehículos/{id}",
  },
  setting: {
    path: "/vehicles/setting/data",
    title: "Información requerida para la creación de un vehículo",
    subtitle: "Vehículos/Configuración",
  },
  add: {
    path: "/vehicles/add/vehicle",
    title: "Agregar vehículo",
    subtitle: "Vehículos/Agregar Vehículos",
  },
  addOwner: {
    path: "/vehicles/add/user/:id",
    title: "Agregar Propietario vehicular",
    subtitle: "Vehículos/{id}",
  },
  owner: {
    path: "/vehicles/owner/:id",
    title: "Propietario vehicular",
    subtitle: "Vehículos/Configuración/{id}",
  },
};

// ==========================================
// RUTAS DE TARIFARIO
// ==========================================
export const RATES_ROUTES = {
  main: {
    path: "/rates",
    title: "Tarifas",
    subtitle: "Tarifas",
    description: "Gestión de tarifas por kilómetro, carga y cliente",
  },
  rate: {
    path: "/rates/:id",
    title: "Detalle de Tarifa",
    subtitle: "Tarifas/{id}",
  },
  setting: {
    path: "/rates/setting/data",
    title: "Configuración de Tarifas",
    subtitle: "Tarifas/Configuración",
    description: "Parámetros y ajustes del sistema de tarifas",
  },
  advances: {
    path: "/rates/advances",
    title: "Anticipos",
    subtitle: "Tarifas/Anticipos",
    description: "Gestión de anticipos de pago",
  },
  advanceConfirmation: {
    path: "/rates/advances/:id/confirm",
    title: "Confirmar Anticipo",
    subtitle: "Tarifas/Anticipos/Confirmación",
    description: "Comprobante de confirmación de anticipo",
  },
};

// ==========================================
// RUTAS DE MANIFIESTOS
// ==========================================
export const MANIFEST_ROUTES = {
  main: {
    path: "/manifest-control",
    title: "Control de Manifiestos",
    subtitle: "Manifiestos",
    description: "Gestión y control de manifiestos de carga",
  },
  guides: {
    path: "/manifest-control/guides",
    title: "Guías",
    subtitle: "Manifiestos/Guías",
    description: "Gestión de guías asociadas a manifiestos",
  },
  guideDashboard: {
    path: "/manifest-control/guide-dashboard",
    title: "Dashboard de Guías",
    subtitle: "Manifiestos/Dashboard Guías",
    description: "Vista general de todas las guías con filtros y detalle",
  },
  setting: {
    path: "/manifest-control/setting/data",
    title: "Configuración de Manifiestos",
    subtitle: "Manifiestos/Configuración",
    description: "Parámetros y ajustes del sistema de manifiestos",
  },
};

export const ROUTES = {
  Administrador: {
    dashboard: "/dashboard",
    agregarInfo: "/agregar-info",
    reportes: "/reportes",
    perfil: "/perfil",
    persons: "/persons",
    satellite: "/satellite-uploader",
    register: "/register",
    trends: "/trends",
    hotspots: "/hotspots",
    repeatOffenders: "/repeat-offenders",
    users: "/users",
    vehicles: "/vehicles",
    carriers: "/carriers",
    message: "/message",
  },
  vehicle: {
    dashboard: "/dashboard",
    agregarInfo: "/agregar-info",
    perfil: "/perfil",
  },
  thirdParty: {
    dashboard: "/dashboard",
    perfil: "/perfil",
  },
};

export const OPERATIONS_ROUTES = {
  main: {
    path: "/scheduler",
    title: "Operaciones",
    subtitle: "Operaciones/",
  },
  impala: {
    path: "/scheduler/impala",
    title: "Impala",
    subtitle: "Operaciones/Impala",
  },
  frontera: {
    path: "/scheduler/frontera",
    title: "Frontera",
    subtitle: "Operaciones/Frontera",
  },
  terpel: {
    path: "/scheduler/terpel",
    title: "Terpel",
    subtitle: "Operaciones/Terpel",
  },
  ecopetrol: {
    path: "/scheduler/ecopetrol",
    title: "Ecopetrol",
    subtitle: "Operaciones/Ecopetrol",
  },
  granTierra: {
    path: "/scheduler/gran-tierra-energy",
    title: "Gran Tierra Energy",
    subtitle: "Operaciones/Gran Tierra Energy",
  },
  GTESeca: {
    path: "/scheduler/gran-tierra-energy-seca",
    title: "Gran Tierra Energy Seca",
    subtitle: "Operaciones/Gran Tierra Energy Seca",
  },
  GTELiquida: {
    path: "/scheduler/gran-tierra-energy-liquida",
    title: "Gran Tierra Energy Líquida",
    subtitle: "Operaciones/Gran Tierra Energy Líquida",
  },
  emerald: {
    path: "/scheduler/emerald-energy",
    title: "Emerald Energy",
    subtitle: "Operaciones/Emerald Energy",
  },
  terpelNorte: {
    path: "/scheduler/terpel-norte",
    title: "Terpel Norte",
    subtitle: "Operaciones/Terpel Norte",
  },
  terpelSur: {
    path: "/scheduler/terpel-sur",
    title: "Terpel Sur",
    subtitle: "Operaciones/Terpel Sur",
  },
  dobletroques: {
    path: "/scheduler/dobletroques-ecopetrol",
    title: "Dobletroques Ecopetrol",
    subtitle: "Operaciones/Dobletroques Ecopetrol",
  },
  regalias: {
    path: "/scheduler/regalias-ecopetrol",
    title: "Regalías Ecopetrol",
    subtitle: "Operaciones/Regalías Ecopetrol",
  },
  emeraldEnergy: {
    path: "/scheduler/emerald",
    title: "Emerald Energy",
    subtitle: "Operaciones/Emerald Energy",
  },
  twm: {
    path: "/scheduler/twm",
    title: "TWM",
    subtitle: "Operaciones/TWM",
  },
  serviciosPetroleros: {
    path: "/scheduler/servicios-petroleros",
    title: "Servicios Petroleros",
    subtitle: "Operaciones/Servicios Petroleros",
  },
  granTierraEnergy: {
    path: "/scheduler/g-t-e",
    title: "Gran Tierra Energy",
    subtitle: "Operaciones/Gran Tierra Energy",
  },
  inspectrol: {
    path: "/scheduler/inspectrol",
    title: "Inspectrol",
    subtitle: "Operaciones/Inspectrol",
  },
  solucionesCap: {
    path: "/scheduler/soluciones-cap",
    title: "Soluciones CAP",
    subtitle: "Operaciones/Soluciones CAP",
  },
  confipetrol: {
    path: "/scheduler/confipetrol",
    title: "Confipetrol",
    subtitle: "Operaciones/Confipetrol",
  },
  servipvalencia: {
    path: "/scheduler/servipvalencia",
    title: "Servipvalencia",
    subtitle: "Operaciones/Servipvalencia",
  },
  parex: {
    path: "/scheduler/parex",
    title: "PAREX",
    subtitle: "Operaciones/PAREX",
  },
  patterson: {
    path: "/scheduler/patterson",
    title: "PATTERSON",
    subtitle: "Operaciones/PATTERSON",
  },
  setting: {
    path: "/scheduler/setting/data",
    title: "Configuración de datos",
    subtitle: "Operaciones/Configuración",
  },
};

// HELP_ROUTES sin las rutas de documentación
export const HELP_ROUTES = {
  main: {
    path: "/help",
    title: "Centro de Ayuda",
    subtitle: "Centro de Ayuda/",
    category: "main",
  },
  tickets: {
    path: "/help/tickets",
    title: "Tickets",
    subtitle: "Centro de Ayuda/Tickets",
    category: "main",
  },
  ticketDepartment: {
    path: "/help/tickets/department/:departmentId",
    title: "Departamento de Tickets",
    subtitle: "Centro de Ayuda/Gestión de Tickets/Departamento",
    category: "main",
    parent: "Tickets",
  },
  // Privacidad y tratamiento de datos
  accessibility: {
    path: "/help/privacy/accessibility",
    title: "Declaración de accesibilidad",
    subtitle: "Centro de Ayuda/Privacidad/Declaración de accesibilidad",
    category: "privacy",
    parent: "Privacidad y tratamiento de datos",
  },
  dataProcessing: {
    path: "/help/privacy/data-processing",
    title: "Privacidad y tratamiento de datos",
    subtitle: "Centro de Ayuda/Privacidad/Privacidad y tratamiento de datos",
    category: "privacy",
    parent: "Privacidad y tratamiento de datos",
  },
  termsConditions: {
    path: "/help/privacy/terms-conditions",
    title: "Términos y condiciones de uso",
    subtitle: "Centro de Ayuda/Privacidad/Términos y condiciones de uso",
    category: "privacy",
    parent: "Privacidad y tratamiento de datos",
  },
  informationProtection: {
    path: "/help/privacy/information-protection",
    title: "Guía del Sistema de Protección de la Información",
    subtitle:
      "Centro de Ayuda/Privacidad/Sistema de Protección de la Información",
    category: "privacy",
    parent: "Privacidad y tratamiento de datos",
  },
  // Contacto
  contact: {
    path: "/help/contact",
    title: "Contacto",
    subtitle: "Centro de Ayuda/Contacto",
    category: "main",
  },
  // Documentacion - Microservicio Tracking
  tracking: {
    path: "/help/documentation/tracking",
    title: "Microservicio Tracking v2.0",
    subtitle: "Centro de Ayuda/Documentación/Tracking v2.0",
    category: "documentation",
  },
  trackingDoc: {
    path: "/help/documentation/tracking/:docId",
    title: "Documentación Tracking",
    subtitle: "Centro de Ayuda/Documentación/Tracking v2.0",
    category: "documentation",
    parent: "Microservicio Tracking v2.0",
  },
};

// ==========================================
// UTILIDADES PARA EL SISTEMA DE CARPETAS
// ==========================================

/**
 * Obtiene la configuración de ruta para carpetas basada en el rol
 * @param {number} roleId - ID del rol
 * @returns {Object} Configuración de ruta específica para el rol
 */
export const getFolderRouteByRole = (roleId) => {
  const roleRouteMap = {
    4: "folderAdministrators",
    5: "folderOperators",
    6: "folderOwners",
    1: "folderRRHH",
    3: "folderThirdParties",
  };

  const routeKey = roleRouteMap[roleId];
  return routeKey ? PERSON_ROUTES[routeKey] : null;
};

/**
 * Construye la ruta completa de una carpeta específica
 * @param {number} folderId - ID de la carpeta
 * @param {number} roleId - ID del rol (opcional)
 * @returns {string} Ruta construida
 */
export const buildFolderPath = (folderId, roleId = null) => {
  const basePath = `/persons/folders/${folderId}`;

  if (!roleId) return basePath;

  const rolePathMap = {
    4: "/administrators",
    5: "/operators",
    6: "/owners",
    1: "/rrhh",
    3: "/third-parties",
  };

  const rolePath = rolePathMap[roleId];
  return rolePath ? `${basePath}${rolePath}` : basePath;
};

/**
 * Analiza y extrae información de rutas del sistema de carpetas
 * Maneja todos los tipos de rutas: principales, carpetas específicas, unassigned y manage
 * @param {string} pathname - Ruta actual
 * @returns {Object|null} Información extraída de la ruta
 */
export const parseFolderRoute = (pathname) => {
  // Regex para rutas de carpetas específicas con roles
  const folderRouteRegex =
    /^\/persons\/folders(?:\/(\d+))?(?:\/(operators|administrators|owners|rrhh|third-parties))?$/;

  // Regex para rutas especiales de gestión (ACTUALIZADO para incluir "all")
  const specialRouteRegex =
    /^\/persons\/folders\/(unassigned|manage|all)\/(\d+)$/;

  // Verificación explícita de ruta principal
  if (pathname === "/persons/folders") {
    return {
      isFolderSystem: true,
      folderId: null,
      roleType: null,
      roleId: null,
      isMainFolderView: true,
      isSpecificFolder: false,
      hasRoleSpecific: false,
      isSpecialRoute: false,
      specialRouteType: null,
    };
  }

  // Procesamiento de rutas especiales con prioridad (INCLUYE "all")
  const specialMatch = pathname.match(specialRouteRegex);
  if (specialMatch) {
    return {
      isFolderSystem: true,
      folderId: null,
      roleType: null,
      roleId: parseInt(specialMatch[2]),
      isMainFolderView: false,
      isSpecificFolder: false,
      hasRoleSpecific: false,
      isSpecialRoute: true,
      specialRouteType: specialMatch[1], // 'unassigned' | 'manage' | 'all'
    };
  }

  // Procesamiento de rutas de carpetas normales
  const folderMatch = pathname.match(folderRouteRegex);
  if (folderMatch) {
    return {
      isFolderSystem: true,
      folderId: folderMatch[1] ? parseInt(folderMatch[1]) : null,
      roleType: folderMatch[2] || null,
      roleId: null,
      isMainFolderView: false,
      isSpecificFolder: !!folderMatch[1],
      hasRoleSpecific: !!folderMatch[2],
      isSpecialRoute: false,
      specialRouteType: null,
    };
  }

  return null; // No es una ruta del sistema de carpetas
};
/**
 * Verifica si una ruta es parte del sistema de carpetas (actualizada)
 * @param {string} pathname - Ruta actual
 * @returns {boolean} True si es ruta de carpetas
 */
export const isFolderRoute = (pathname) => {
  return parseFolderRoute(pathname) !== null;
};

// Combinación de rutas help completas
export const COMPLETE_HELP_ROUTES = combineHelpRoutes(
  HELP_ROUTES,
  HELP_ROUTES_FILE_EXPLORE
);

// ==========================================
// RUTAS DE PREOPERACIONAL
// ==========================================
export const PREOP_ROUTES = {
  // Configuracion de RRHH (Gerenciamiento de viajes)
  configHSEQ: {
    path: "/gerenciamiento-viajes/config",
    title: "Configuracion RRHH",
    subtitle: "Gerenciamiento/Configuracion",
    description: "Configuracion de Google Forms, Sheets, parseo y notificaciones para RRHH",
  },
  // Configuracion de MTTO (Mantenimiento)
  configMTTO: {
    path: "/preoperacional/config",
    title: "Configuracion Mantenimiento",
    subtitle: "Preoperacional/Configuracion",
    description: "Configuracion de Google Forms, Sheets, parseo y notificaciones para Mantenimiento",
  },
  // Vista de Gerenciamiento de viajes (RRHH)
  gerenciamiento: {
    path: "/gerenciamiento-viajes",
    title: "Gerenciamiento de viajes",
    subtitle: "Gerenciamiento de viajes",
    description: "Seguimiento de formularios preoperacionales y notificaciones",
  },
  // Vista de Preoperacional (MTTO - Mantenimiento)
  preoperacional: {
    path: "/preoperacional",
    title: "Preoperacional",
    subtitle: "Preoperacional",
    description: "Gestion de formularios preoperacionales de mantenimiento",
  },
};
